import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import { Scrollbars } from "react-custom-scrollbars";

import Notification from "../Notification";

import getAndroidVersion from "../../../../utils/getAndroidVersion";

import { useStore } from "../../../../connect";

import strings from "../../../../locales/strings";

import styles from "./PushNotificationContainer.scss";

const cx = classnames.bind(styles);

const mobileControlsHeightPx = 187;
const desktopControlsHeightPx = 187;

const androidVersion = getAndroidVersion();

const PushNotificationContainer = ({ mobile }) => {
  const { notifications } = useStore();

  return (
    <div className={cx("scrollbar-holder")}>
      {notifications.notificationFromPush ? (
        <Scrollbars
          autoHeight
          autoHeightMax={
            mobile && androidVersion && androidVersion >= 4.6
              ? `calc(100vh - ${mobileControlsHeightPx}px)`
              : `calc(100vh - ${desktopControlsHeightPx}px)` || 223
          }
          autoHeightMin={110}
          className={cx("scrollpanel")}
        >
          <div className={cx("notification-content")}>
            <Notification notification={notifications.notificationFromPush} />
          </div>
        </Scrollbars>
      ) : (
        <div className={cx("notification-loading-error")}>
          {strings.loadingError}
        </div>
      )}
    </div>
  );
};

PushNotificationContainer.propTypes = {
  mobile: PropTypes.bool,
};

export default observer(PushNotificationContainer);
